(function($) {
    const $select = $('.js-abm-gallery-filter');

    $select.on('change', function(e) {
        const url = $(this).find('option:selected').val();
        window.location.href = url;
    });
})(jQuery);